import { DropdownTheme } from "@acin.reactjs/acin-ui/dropdown";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const dropdownTheme: ComponentCSSStyle<DropdownTheme> = {
  variants: {
    publicContestSelector: {
      root: {
        margin: "8px 0",
        boxShadow: "0 3px 32px 0 #0000001A",
        borderRadius: "20px",
        padding: "24px",
        zIndex: 5,
        width: "530px",
      },
    },
  },
};

export default dropdownTheme;
